import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupDirective } from '@angular/forms';

import { Nullable } from '@assess/shared/type-utilities';

@Component({ template: '' })
export class AbstractFormComponent implements OnInit {
  @Input() formGroupName: Nullable<string>;
  @Input() controlName!: string;
  form!: FormGroup;
  control!: AbstractControl;
  path!: string;

  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    if (this.formGroupName) {
      this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
      this.path = `${this.formGroupName}.${this.controlName}`;
    } else {
      this.form = this.rootFormGroup.form;
      this.path = this.controlName;
    }
  }

  hasError() {
    return this.rootFormGroup.hasError(this.path);
  }

  getError() {
    return this.rootFormGroup.getError(this.path);
  }
}
